export default [() => {

  const readableSlug = (text = null) => {
    if ( !text ) { return; }
    return text.replace(new RegExp('_', 'g'), ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  };

  const caps = (text = null) => {
      if ( !text ) { return; }
      return text.toUpperCase();
  };

  return {
    deslug: (text = null) => readableSlug(text),
    uppercase: (text = null) => caps(text)
  };
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/readability.service.js